import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function SectorCard({ sector, index }) {
  return (
    <Link
      to={sector.href}
      data-testid={`sector-card-${sector.id}`}
      className="group relative block overflow-hidden rounded-2xl bg-[#1F2937] min-h-[460px] md:min-h-[520px]"
    >
      <img
        src={sector.image}
        alt={sector.title}
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105 opacity-90"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0b1220] via-[#0b1220]/55 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#10B981]/0 group-hover:from-[#10B981]/15 transition-all duration-500" />

      <div className="relative h-full w-full p-7 md:p-9 flex flex-col justify-end">
        <div className="absolute top-7 left-7 md:top-9 md:left-9 right-7 md:right-9 flex items-center justify-between text-white/80">
          <span className="text-xs font-semibold tracking-[0.24em] uppercase">{sector.kicker}</span>
          <span className="font-display text-sm">0{index + 1}/03</span>
        </div>

        <div className="text-white">
          <h3 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-4 text-balance">
            {sector.title}
          </h3>
          <p className="text-white/85 max-w-md text-base leading-relaxed mb-6">{sector.blurb}</p>
          <span
            data-testid={`sector-card-cta-${sector.id}`}
            className="inline-flex items-center gap-2 px-5 py-3 rounded-lg bg-[#0055A4] group-hover:bg-[#003D7A] text-white font-semibold shadow-md transition-all"
          >
            Découvrir nos solutions
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </span>
        </div>
      </div>
    </Link>
  );
}
